import "react-tooltip/dist/react-tooltip.css";
import React, { useEffect, useRef, useCallback } from "react";
import { API_BASE_URL } from "./config";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";
import { Home, AdminPage } from "./components/index";
import Auth from "./auth";
import { getalldata } from "./components/pages/admin-component/adminpanel/hooks/apis";
import { useDispatch } from "react-redux";

// uncommment it.
// import { PrivateRoute } from "./components/pages/private/privateroute";
// import PageNotFound from "./components/pages/private/page404";
import { purewebContext } from "./context/PurewebContext";
import { useState } from "react";
import InterlucentEmulator from "./components/pages/admin-component/interlucentemulator";

// Inject a CSS rule that hides the Tawk bubble. Used to suppress the widget on
// /render once the user has logged in (belt-and-suspenders alongside hideWidget()).
// Before login the bubble is left visible, so this is only applied post-login.
const TAWK_HIDE_ID = "tawk-render-hide";
function injectTawkHide() {
  if (!document.getElementById(TAWK_HIDE_ID)) {
    const style = document.createElement("style");
    style.id = TAWK_HIDE_ID;
    // Target the iframe elements directly (by id/title), not just `.widget-visible`.
    // Tawk inserts its iframe — already showing the "we are here" greeting — a moment
    // BEFORE it adds the `.widget-visible` class. Hiding only `.widget-visible` leaves
    // that gap visible, which is the flicker. Matching the iframe by its stable id/title
    // hides it the instant it lands in the DOM, with no flash.
    style.textContent =
      "#tawkchat-minified-iframe, #tawkchat-iframe, iframe[title='chat widget'], .widget-visible { display: none !important; }";
    document.head.appendChild(style);
  }
}
function removeTawkHide() {
  document.getElementById(TAWK_HIDE_ID)?.remove();
}

export default function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const handleError = (error) => {
      console.error("🚨 ERROR CAUGHT:", error);
    };

    const handleUnhandledRejection = (event) => {
      console.error("🚨 UNHANDLED PROMISE REJECTION:", event.reason);
      event.preventDefault();
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection
      );
    };
  }, []);

  const [imgbbContainerVisible, setImgbbContainerVisible] = useState(false);
  const [upload3DContainerVisible, setUpload3DContainerVisible] =
    useState(false);
  const [imageTo3DContainerVisible, setImageTo3DContainerVisible] =
    useState(false);
  const [playfabData, setPlayfabData] = useState([]);
  // True once a signed-in user is confirmed to be a rendernow.co admin (their email is
  // in the admin registry). Independent of how many users their domain has, unlike
  // playfabData which can be an empty array for a brand-new admin.
  const [isAdmin, setIsAdmin] = useState(false);
  const [currentEmitter, setCurrentEmitter] = useState(null);
  const [downloadVisible, setDownloadVisible] = useState(false);
  const [preparingDownload, setPreparingDownload] = useState(false);
  const [renderStarted, setRenderStarted] = useState(false);
  const [imagefileone, setImagefileone] = useState("");
  const [videofileone, setVideofileone] = useState("");
  const [renderDownloadUrl, setRenderDownloadUrl] = useState("");
  const [exportDownloadUrl, setExportDownloadUrl] = useState("");
  const [fullScreenTrigger, setFullScreenTrigger] = useState("noinit");
  const [refreshRequiredModalVisible, setRefreshRequiredModalVisible] =
    useState(false);
  /** Why the refresh modal opened: loading | login | stream */
  const [refreshModalReason, setRefreshModalReason] = useState(null);
  const [lowConnectionMessageVisible, setLowConnectionMessageVisible] =
    useState(false);
  const [
    connectionSuccessLoadingApplication,
    setConnectionSuccessLoadingApplication,
  ] = useState(false);
  const [shownNetworkMessage, setShownNetworkMessage] = useState(false);
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [hasLoggedInOnce, setHasLoggedInOnce] = useState(false);

  const [canSkipVideo, setCanSkipVideo] = useState(false);
  const [loginVisible, setLoginVisible] = useState(false);

  // const [streamQuality, setStreamQuality] = useState(localStorage.getItem("streamQuality") || "fhd");
  const [streamQuality, setStreamQuality] = useState("fhd");
  const [tutorials, setTutorials] = useState([]);
  const [isOverlayActive, setIsOverlayActive] = useState(false);

  // timers
  const LOGIN_TIMEOUT_SEC = 40;
  // Servers have been starting in 40-60s lately (was ~20-40s), so give loading
  // 90s before prompting a refresh. The in-screen "still connecting" banner
  // appears at 70s elapsed (loadingTimeLeft <= 20) — see LoadingScreen.js.
  const LOADING_TIMEOUT_SEC = 90;
  const [timeLeft, setTimeLeft] = useState(LOGIN_TIMEOUT_SEC);
  const [loadingTimeLeft, setLoadingTimeLeft] = useState(LOADING_TIMEOUT_SEC);
  const hasRefreshRequiredModalVisibleTriggered = useRef(false);
  const loadingSucceededRef = useRef(false);
  const loginSucceededRef = useRef(false);

  const timerIdRef = useRef(null);
  const loadingTimerIdRef = useRef(null);
  const chatIsMaximizedRef = useRef(false);
  // Tawk is lazy-loaded on /render (only when the user opens chat) to avoid the
  // widget flashing before it can be hidden. These track that one-time load and a
  // deferred "open the chat as soon as it finishes loading" request.
  const tawkScriptInjectedRef = useRef(false);
  const pendingMaximizeRef = useRef(false);
  // Mirror of userLoggedIn for use inside Tawk's callbacks (which capture state
  // at registration time and so can't read the live value directly).
  const userLoggedInRef = useRef(false);

  const startTimer = () => {
    clearInterval(timerIdRef.current);
    timerIdRef.current = null;
    loginSucceededRef.current = false;
    setTimeLeft(LOGIN_TIMEOUT_SEC);
    timerIdRef.current = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerIdRef.current);
          timerIdRef.current = null;
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };

  const startLoadingTimer = () => {
    clearInterval(loadingTimerIdRef.current);
    loadingTimerIdRef.current = null;
    loadingSucceededRef.current = false;
    hasRefreshRequiredModalVisibleTriggered.current = false;
    setLoadingTimeLeft(LOADING_TIMEOUT_SEC);
    loadingTimerIdRef.current = setInterval(() => {
      setLoadingTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(loadingTimerIdRef.current);
          loadingTimerIdRef.current = null;
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (document.querySelector(".marker-app")) {
      if (location.pathname === "/render") {
        document.querySelector(".marker-app").style.display = "block";
      } else {
        document.querySelector(".marker-app").style.display = "none";
      }
    }
  }, [location]);

  // Route- and login-aware Tawk widget visibility control.
  //
  // On /render we keep the chat bubble VISIBLE until the user logs in
  // (SDK_Login_Success flips userLoggedIn), then hide it. Showing the bubble
  // until login is intentional: it lets logged-out users reach support, and —
  // crucially — it avoids the flicker. The old approach loaded Tawk and then
  // immediately fought its render with hide-CSS + hideWidget(), so the bubble
  // flashed in the gap before it could be suppressed. By letting Tawk render
  // normally and only hiding once (after login) there is no show/hide race and
  // no flash. The script stays loaded throughout, so presence tracking is active
  // for the whole /render session regardless of visibility.
  useEffect(() => {
    const isRenderRoute = location.pathname === "/render";
    const shouldHide = isRenderRoute && userLoggedIn;
    if (shouldHide) {
      chatIsMaximizedRef.current = false; // reset stale flag from other routes
      injectTawkHide();
    } else {
      removeTawkHide();
    }
    try {
      if (window.Tawk_API && typeof window.Tawk_API.hideWidget === "function") {
        if (shouldHide) {
          window.Tawk_API.hideWidget();
        } else {
          window.Tawk_API.showWidget();
        }
      }
    } catch (_) {}
  }, [location, userLoggedIn]);

  // Keep the ref in sync so Tawk's callbacks (registered once) can read live login state.
  useEffect(() => {
    userLoggedInRef.current = userLoggedIn;
  }, [userLoggedIn]);

  useEffect(() => {
    if (hasRefreshRequiredModalVisibleTriggered.current) {
      return;
    }

    if (timeLeft === 0 && !loginSucceededRef.current) {
      hasRefreshRequiredModalVisibleTriggered.current = true;
      setRefreshModalReason("login");
      setRefreshRequiredModalVisible(true);
      stopTimer();
      stopLoadingTimer();
    } else if (loadingTimeLeft === 0 && !loadingSucceededRef.current) {
      hasRefreshRequiredModalVisibleTriggered.current = true;
      setRefreshModalReason("loading");
      setRefreshRequiredModalVisible(true);
      stopLoadingTimer();
    }
  }, [timeLeft, loadingTimeLeft]);

  const stopTimer = () => {
    loginSucceededRef.current = true;
    clearInterval(timerIdRef.current);
    timerIdRef.current = null;
  };

  const stopLoadingTimer = () => {
    loadingSucceededRef.current = true;
    clearInterval(loadingTimerIdRef.current);
    loadingTimerIdRef.current = null;
  };

  // Inject the Tawk script (once) and wire up its callbacks. On other routes this
  // runs at startup; on /render it runs only when the user first opens chat, so the
  // widget never renders — and therefore never flickers — until it's actually wanted.
  const loadTawk = useCallback(() => {
    if (tawkScriptInjectedRef.current) return;
    tawkScriptInjectedRef.current = true;

    window.Tawk_API = window.Tawk_API || {};

    // Register event callbacks BEFORE injecting the script tag so Tawk reads them
    // at initialization time.
    window.Tawk_API.onChatMaximized = function () {
      chatIsMaximizedRef.current = true;
    };
    window.Tawk_API.onChatMinimized = function () {
      if (chatIsMaximizedRef.current) {
        chatIsMaximizedRef.current = false;
        // Only fully hide the widget on /render AFTER login. Pre-login (and on
        // other routes) let Tawk fall back to its default minimized bubble so the
        // user can reopen the chat.
        if (window.location.pathname === "/render" && userLoggedInRef.current) {
          injectTawkHide();
          try { window.Tawk_API?.hideWidget?.(); } catch (_) {}
        }
      }
      // else: spurious fire from showWidget() — ignore
    };
    window.Tawk_API.onChatEnded = function () {
      chatIsMaximizedRef.current = false;
      // Same rule: only disappear completely on /render once logged in; keep the bubble otherwise.
      if (window.location.pathname === "/render" && userLoggedInRef.current) {
        injectTawkHide();
        try { window.Tawk_API?.hideWidget?.(); } catch (_) {}
      }
    };

    const prevOnLoad = window.Tawk_API.onLoad;
    window.Tawk_API.onLoad = function () {
      try {
        if (pendingMaximizeRef.current) {
          // The user clicked "Live Chat Support" before the script finished
          // loading. Reveal and open the chat now that it's ready.
          pendingMaximizeRef.current = false;
          removeTawkHide();
          window.Tawk_API.showWidget();
          window.Tawk_API.maximize();
        } else if (window.location.pathname === "/render" && userLoggedInRef.current) {
          // Only hide on load if the user is already logged in. Before login the
          // bubble should stay visible on /render (and showing it normally is what
          // avoids the flicker).
          window.Tawk_API.hideWidget();
        }
      } catch (_) {}
      if (typeof prevOnLoad === "function") prevOnLoad();
    };

    var Tawk_LoadStart = new Date();
    (function () {
      var s1 = document.createElement("script"),
        s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = "https://embed.tawk.to/610eea1ed6e7610a49af1a2d/1fch4524j";
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");
      s0.parentNode.insertBefore(s1, s0);
    })();
  }, []);

  // Open chat on request from the menu. Lazy-loads Tawk on first use (on /render),
  // otherwise reveals and maximizes the already-loaded widget.
  const openChat = useCallback(() => {
    if (!tawkScriptInjectedRef.current) {
      pendingMaximizeRef.current = true; // onLoad will reveal + maximize
      loadTawk();
      return;
    }
    if (typeof window.Tawk_API?.maximize === "function") {
      removeTawkHide();
      try {
        window.Tawk_API.showWidget();
        window.Tawk_API.maximize();
      } catch (_) {}
    } else {
      // Script injected but not finished loading yet — defer to onLoad.
      pendingMaximizeRef.current = true;
    }
  }, [loadTawk]);

  useEffect(() => {
    window.addEventListener("tawk:request-open", openChat);
    return () => window.removeEventListener("tawk:request-open", openChat);
  }, [openChat]);

  useEffect(() => {
    dispatch({ type: "load_loader" });
    const exec = async () => {
      const response = await getalldata(dispatch);
      const executefun = async () => {
        await fetch(`${API_BASE_URL}/`);
      };
      executefun();
      if (response) {
        dispatch({ type: "unload_loader" });
        // Eager-load Tawk on EVERY route, including /render. Tawk's presence
        // tracking (which users are live on the page) only works while the script
        // is actually loaded, so it must load on /render too — the team relies on
        // this to see who's on the render page. On /render the bubble is shown
        // until login and hidden afterward (see the visibility effect above), so
        // presence stays active for the whole session either way.
        loadTawk();
      }
    };
    exec();
  }, [loadTawk]);

  useEffect(() => {
    localStorage.setItem("streamQuality", streamQuality);
  }, [streamQuality]);

  useEffect(() => {
    // On any pointer down in the parent page, blur any focused iframe so the
    // tawk.to chat widget cannot hold keyboard focus while the user interacts
    // with the 3D viewport. Clicks INSIDE the chat iframe never fire here,
    // so the user can still type in the chat normally.
    const handlePointerDown = () => {
      const active = document.activeElement;
      if (active && active.tagName === "IFRAME") {
        active.blur();
        document.body.focus();
      }
    };

    document.addEventListener("pointerdown", handlePointerDown, true);

    return () => {
      document.removeEventListener("pointerdown", handlePointerDown, true);
    };
  }, []);

  return (
    <div>
      <purewebContext.Provider
        value={{
          upload3DContainerVisible,
          setUpload3DContainerVisible,
          imgbbContainerVisible,
          setImgbbContainerVisible,
          imageTo3DContainerVisible,
          setImageTo3DContainerVisible,
          currentEmitter,
          setCurrentEmitter,
          downloadVisible,
          setDownloadVisible,
          preparingDownload,
          setPreparingDownload,
          renderStarted,
          setRenderStarted,
          imagefileone,
          setImagefileone,
          videofileone,
          setVideofileone,
          renderDownloadUrl,
          setRenderDownloadUrl,
          exportDownloadUrl,
          setExportDownloadUrl,
          fullScreenTrigger,
          setFullScreenTrigger,
          refreshRequiredModalVisible,
          setRefreshRequiredModalVisible,
          refreshModalReason,
          setRefreshModalReason,
          lowConnectionMessageVisible,
          setLowConnectionMessageVisible,
          shownNetworkMessage,
          setShownNetworkMessage,
          startTimer,
          stopTimer,
          startLoadingTimer,
          stopLoadingTimer,
          loadingTimeLeft,
          connectionSuccessLoadingApplication,
          setConnectionSuccessLoadingApplication,
          userLoggedIn,
          setUserLoggedIn,
          hasLoggedInOnce,
          setHasLoggedInOnce,
          streamQuality,
          setStreamQuality,
          setPlayfabData,
          playfabData,
          isAdmin,
          setIsAdmin,
          canSkipVideo,
          setCanSkipVideo,
          tutorials,
          setTutorials,
          loginVisible,
          setLoginVisible,
          isOverlayActive,
          setIsOverlayActive,
        }}
      >
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/auth" component={Auth} />
          {/* remove it */}
          <Route path="/dashboard" component={AdminPage} />
          <Route path="/render" component={InterlucentEmulator} />
          {/* <Route path="/auth/login" component={Emulator} /> */}

          {/* uncomment it */}
          {/* <PrivateRoute path="/dashboard">
            <AdminPage />
          </PrivateRoute> */}
          {/* <Route
            exact
            path={localStorage.getItem("token") ? "/render" : "/no-data"}
            component={Emulator}
          />  
          <Route path="*" component={PageNotFound} /> */}
        </Switch>
      </purewebContext.Provider>
    </div>
  );
}
